<template>
    <div id="AddIntegrationItem" class="content">
        <div class="item">
            <div class="item-image">
                <div class="item-img">
                    <img
                        v-if="integrationType === 'web'"
                        src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                        alt="supsis"
                        style="height: 30px"
                    />
                    <WhatsappIcon v-else-if="integrationType === 'whatsapp'" :color="'#58ca63'" style="height: 30px" />
                    <WhatsappBusinessIcon
                        v-else-if="integrationType === 'whatsapp-business-api'"
                        :color="'#58ca63'"
                        style="height: 30px"
                    />
                    <TelegramIcon v-else-if="integrationType === 'telegram'" style="height: 30px" />
                    <InstagramIcon
                        v-else-if="integrationType === 'instagram'"
                        style="height: 30px"
                        special-background-mode
                    />
                    <MessengerIcon
                        v-else-if="integrationType === 'messenger'"
                        style="height: 30px"
                        special-background-mode
                    />
                    <TrendyolIcon
                        v-else-if="integrationType === 'trendyol'"
                        style="height: 30px"
                    />
                </div>
                <div class="item-text">
                    {{ itemText }}
                </div>
            </div>
            <div class="item-btn">
                <button
                    v-if="integrationType === 'web' && !isChatWidgetInstalled()"
                    class="connect-button"
                    @click="emitEvent"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    Connect
                </button>
                <button
                    v-if="integrationType === 'whatsapp'"
                    class="connect-button"
                    :style="{ color: matchingStoriesCount > 0 ? '#46b451' : '#2372ea' }"
                    @click="whatsappIntegrationMsg"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    {{ matchingStoriesCount > 0 ? `Connected (${matchingStoriesCount})` : "Connect" }}
                </button>
                <button
                    v-if="integrationType === 'whatsapp-business-api'"
                    class="connect-button"
                    :style="{ color: apiMatchingStoriesCount > 0 ? '#46b451' : '#2372ea' }"
                    @click="whatsappApiIntegrationMsg"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    {{ apiMatchingStoriesCount > 0 ? `Connected (${apiMatchingStoriesCount})` : "Connect" }}
                </button>
                <button
                    v-if="integrationType === 'instagram'"
                    class="connect-button"
                    :style="{ color: instagramMatchingStoriesCount > 0 ? '#46b451' : '#2372ea' }"
                    @click="instagramIntegrationMsg"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    {{ instagramMatchingStoriesCount > 0 ? `Connected (${instagramMatchingStoriesCount})` : "Connect" }}
                </button>
                <button
                    v-if="integrationType === 'messenger'"
                    class="connect-button"
                    :style="{ color: messengerMatchingStoriesCount > 0 ? '#46b451' : '#2372ea' }"
                    @click="messengerIntegrationMsg"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    {{ messengerMatchingStoriesCount > 0 ? `Connected (${messengerMatchingStoriesCount})` : "Connect" }}
                </button>
                <button
                    v-if="integrationType === 'trendyol'"
                    class="connect-button"
                    :style="{ color: trendyolMatchingStoriesCount > 0 ? '#46b451' : '#2372ea' }"
                    @click="trendyolIntegrationMsg"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    {{ trendyolMatchingStoriesCount > 0 ? `Connected (${trendyolMatchingStoriesCount})` : "Connect" }}
                </button>
                <button
                    v-if="integrationType === 'telegram' && !isTelegramInstalled()"
                    class="connect-button"
                    @click="emitEvent"
                >
                    <span class="material-icons md-icon" style="font-size: 20px">electrical_services</span>
                    Connect
                </button>
                <a-button
                    v-if="isChatWidgetInstalled() && integrationType === 'web'"
                    type="danger"
                    @click="removeStory"
                >
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
                <a-button
                    v-if="isTelegramInstalled() && integrationType === 'telegram'"
                    type="danger"
                    @click="removeStory"
                >
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
            </div>
            <WhatsappIntegrationsModal
                :title="$t('chatbotv2.whatsappIntegrationTitle')"
                :channels="whatsappChannels"
                :modalVisable="showModal"
                @close="showModal = false"
                @submit="showModal = false"
                v-if="integrationType === 'whatsapp'"
            />
            <WhatsappIntegrationsModal
                :title="$t('chatbotv2.whatsappApiIntegrationTitle')"
                :channels="whatsappApiChannels"
                :modalVisable="showModal"
                @close="showModal = false"
                @submit="showModal = false"
                v-if="integrationType === 'whatsapp-business-api'"
            />
            <InstagramIntegrationsModal
                title="Instagram Chatbot Entegrasyonu"
                :modalVisable="showModal"
                @close="showModal = false"
                @submit="showModal = false"
                v-if="integrationType === 'instagram'"
            />
            <MessengerIntegrationsModal
                title="Messenger Chatbot Entegrasyonu"
                :modalVisable="showModal"
                @close="showModal = false"
                @submit="showModal = false"
                v-if="integrationType === 'messenger'"
            />
            <TrendyolIntegrationsModal
                title="Trendyol Chatbot Entegrasyonu"
                :modalVisable="showModal"
                @close="showModal = false"
                @submit="showModal = false"
                v-if="integrationType === 'trendyol'"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import WhatsappIcon from "../../integrations/svg/WhatsappIcon.vue";
import WhatsappBusinessIcon from "../../integrations/svg/WhatsappBusinessIcon.vue";
import TelegramIcon from "../../integrations/svg/TelegramIcon.vue";
import _ from "lodash";
import WhatsappIntegrationsModal from "../../integrations/components/WhatsappIntegrationsModal.vue";
import InstagramIntegrationsModal from "../../integrations/components/InstagramIntegrationsModal.vue";
import InstagramIcon from "../../integrations/svg/InstagramIcon.vue";
import MessengerIcon from "../../integrations/svg/MessengerIcon.vue";
import MessengerIntegrationsModal from "../../integrations/components/MessengerIntegrationsModal.vue";
import TrendyolIcon from "../../integrations/svg/TrendyolIcon.vue";
import TrendyolIntegrationsModal from "../../integrations/components/TrendyolIntegrationsModal.vue";

export default {
    name: "AddIntegrationItem",
    props: {
        bar: {
            type: Number,
            default: 6,
        },
        storyId: {
            type: String,
            default: "",
        },
        itemText: {
            type: String,
            default: "",
        },
        integrationType: {
            type: String, //web,whatsapp,whatsapp-business-api,telegram,instagram
        },
    },
    components: {
        TrendyolIntegrationsModal,
        TrendyolIcon,
        MessengerIntegrationsModal,
        MessengerIcon,
        InstagramIcon,
        InstagramIntegrationsModal,
        WhatsappIcon,
        WhatsappBusinessIcon,
        TelegramIcon,
        WhatsappIntegrationsModal,
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            whatsappChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-v1", "whatsapp-qr", "whatsapp-v2"].includes(x.type)),
            whatsappApiChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-business-api"].includes(x.type)),
            instagramChannels: (state) => state.channel.channels.filter((x) => ["instagram"].includes(x.type)),
            messengerChannels: (state) => state.channel.channels.filter((x) => ["messenger"].includes(x.type)),
            trendyolChannels: (state) => state.channel.channels.filter((x) => ["trendyol"].includes(x.type)),
        }),
        matchingStoriesCount() {
            return this.whatsappChannels.filter((channel) => channel.forward?.story === this.storyId).length;
        },
        apiMatchingStoriesCount() {
            return this.whatsappApiChannels.filter((channel) => channel.forward?.story === this.storyId).length;
        },
        instagramMatchingStoriesCount() {
            return this.instagramChannels.filter((channel) => channel.forward?.story === this.storyId).length;
        },
        messengerMatchingStoriesCount() {
            return this.messengerChannels.filter((channel) => channel.forward?.story === this.storyId).length;
        },
        trendyolMatchingStoriesCount() {
            return this.trendyolChannels.filter((channel) => channel.commentForward?.story === this.storyId).length;
        },
    },
    methods: {
        emitEvent() {
            this.$emit("connect-event", { functionName: this.connectEmitLog });
        },
        removeStory() {
            this.$emit("remove-story", { functionName: this.removeStoryLog });
        },
        removeStoryLog() {
            console.log("remove-story");
        },
        connectEmitLog() {
            console.log("connect-event");
        },
        isChatWidgetInstalled() {
            const story = this.stories.find((story) => story.id === this.storyId);
            return story ? _.get(story, "integrations.supsisWidget", false) : false;
        },
        isTelegramInstalled() {
            const story = this.stories.find((story) => story.id === this.storyId);
            return story ? _.get(story, "integrations.telegram", false) : false;
        },
        whatsappApiIntegrationMsg() {
            if (this.whatsappApiChannels.length === 0) {
                this.$notification.error({
                    message: "Whatsapp Business API",
                    description: "You do not have a Whatsapp Business API channel, click to create it.",
                    btn: (h) => {
                        return h(
                            "a-button",
                            {
                                props: {
                                    type: "primary",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push("/integrations/whatsapp-business-api");
                                    },
                                },
                            },
                            "Go to page",
                        );
                    },
                });
            } else {
                this.showModal = true;
            }
        },
        instagramIntegrationMsg() {
            if (this.instagramChannels.length === 0) {
                this.$notification.error({
                    message: "Instagram Channel",
                    description: "You do not have a Instagram channel, click to create it.",
                    btn: (h) => {
                        return h(
                            "a-button",
                            {
                                props: {
                                    type: "primary",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push("/integrations/instagram");
                                    },
                                },
                            },
                            "Go to page",
                        );
                    },
                });
            } else {
                this.showModal = true;
            }
        },
        messengerIntegrationMsg() {
            if (this.messengerChannels.length === 0) {
                this.$notification.error({
                    message: "Messenger Channel",
                    description: "You do not have a Messenger channel, click to create it.",
                    btn: (h) => {
                        return h(
                            "a-button",
                            {
                                props: {
                                    type: "primary",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push("/integrations/messenger");
                                    },
                                },
                            },
                            "Go to page",
                        );
                    },
                });
            } else {
                this.showModal = true;
            }
        },
        whatsappIntegrationMsg() {
            if (this.whatsappChannels.length === 0) {
                this.$notification.error({
                    message: "Whatsapp Channel",
                    description: "You do not have a Whatsapp channel, click to create it.",
                    btn: (h) => {
                        return h(
                            "a-button",
                            {
                                props: {
                                    type: "primary",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push("/integrations/whatsapp-v2");
                                    },
                                },
                            },
                            "Go to page",
                        );
                    },
                });
            } else {
                this.showModal = true;
            }
        },
        trendyolIntegrationMsg() {
            if (this.trendyolChannels.length === 0) {
                this.$notification.error({
                    message: "Trendyol Channel",
                    description: "You do not have a Trendyol channel, click to create it.",
                    btn: (h) => {
                        return h(
                            "a-button",
                            {
                                props: {
                                    type: "primary",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push("/integrations/trendyol");
                                    },
                                },
                            },
                            "Go to page",
                        );
                    },
                });
            } else {
                this.showModal = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    margin-bottom: 7px;

    .list-item {
        border: 1px solid #dfdfdf;
        padding: 30px 20px;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
        margin-bottom: 30px;
        position: relative;
        display: flex;

        &.active {
            background-color: #e8eef2;
        }
    }

    .item {
        display: flex;
        justify-content: space-between;
        border: 1px solid #f1e8e8;
        padding: 5px;
        height: 50px;
        align-items: center;
        border-radius: 10px;

        .item-image {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;

            .item-img {
                width: 50px;
                padding: 5px;
                margin-left: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .item-text {
            font-weight: 700;
        }

        .item-btn {
            .connect-button {
                background: transparent;
                border: transparent;
                color: #2372ea;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 5px;
            }
        }
    }
}
</style>
